var icon = require('vue-svgicon')
icon.register({
  'ks-icon-fullscreen': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M22 22h30v12H34v18H22V22m54 0h30v30H94V34H76V22m18 54h12v30H76V94h18V76M52 94v12H22V76h12v18z"/>'
  }
})
